__turbopack_context__.v({
  "className": "rubik_cfdc2ca3-module__IuS3nG__className",
  "variable": "rubik_cfdc2ca3-module__IuS3nG__variable",
});
